<template>
  <main class="main">
    <router-view />
    <Toast position="bottom-right" :baseZIndex="90000000" />
    <!-- <p-vue-confirm-popup></p-vue-confirm-popup> -->
    <p-success-or-failed
      v-if="generalSuccessOrFailedModal.visible"
      :message="generalSuccessOrFailedModal.message"
      :showCloseBtn="generalSuccessOrFailedModal.showCloseBtn"
      :isSuccess="generalSuccessOrFailedModal.isSuccess"
      :timeout="generalSuccessOrFailedModal.timeout"
    />
  </main>
</template>

<script>
import { onBeforeMount } from "vue";
import Toast from "primevue/toast";
import { mapState, useStore } from "vuex";
import { languages } from "../public/local";
import { getGlobalApi } from "@/services/APointAPI";
import { SessionTokenGetData } from "./services/APointAPI";
import { errorReceived } from "@/services/apointUtil";
import { __ } from "@/plugins/i18n/index";
import PrimeVueLocalConfigs from "./configs/primevue";
import PSuccessOrFailed from "@/components/partials/p-success-or-failed";
import { getWorkerData } from "@/services/service";
export default {
  components: {
    Toast,
    PSuccessOrFailed,
  },
  data() {
    return {
      localeConfig: null,
      myUrlPath: null,
    };
  },
  watch: {
    generalErrorToast() {
      if (this.generalErrorToast.visible === true) {
        this.$toast.add({
          severity: "error",
          summary: this.generalErrorToast.summaryText,
          detail: this.generalErrorToast.detailText,
          life: 3000,
        });
        this.$store.commit("setGeneralErrorToast", { visible: false });
      }
    },
    language() {
      this.setLocaleInPrimeVue(this.primevueLocale);
    },
    generalSuccessOrFailedModal() {
      if (this.generalSuccessOrFailedModal.visible) {
        setTimeout(() => {
          this.$store.commit("setGeneralSuccessOrFailedModal", {
            visible: false,
          });
        }, this.generalSuccessOrFailedModal.timeout);
      }
    },
  },
  mounted() {
    // console.log("app mounted");
    this.$store.commit("api/setSessionData", {
      hideNavigation: false,
    });
    this.$cookie.config({
      expire: "60d",
      path: "/",
      domain: "",
      secure:
      window.location.host.substring(0, 9) === "localhost" ? false : true, //for debugging
      sameSite: "Lax",
    });
    const queryString = window.location.href
    .split("?")[1]
    ?.split("#")[0]
    .toLowerCase();
    if (queryString) {
      const urlParams = new URLSearchParams(queryString);
      if (urlParams.get("sessintoken")) {
        SessionTokenGetData(urlParams.get("sessintoken"));
      } else if (urlParams.get("userinfo")) {
        const userInfo = urlParams.get("userinfo");
        const [userName, userPswd] = userInfo.split(",");
        window.navigator?.splashscreen?.hide();
        this.$store.commit("api/setSessionData", {
          compID: urlParams.get("cpid"),
          sessionToken: urlParams.get("st"),
          buildingAddress: urlParams.get("fa"),
          hideNavigation: urlParams.get("hn"),
          userName: userName,
          userPswd: userPswd,
          loggedIn: true,
          User: { userName: userName, pswd: userPswd },
        });
        getWorkerData()
      } else {
        this.$store.commit("api/setSessionData", {
          bID: +urlParams.get("bid"),
          compID: +urlParams.get("compid"),
        });
      }
      window.history.replaceState(null, null, window.location.pathname);
      // window.location.href = "/";
    }
    this.$store.commit("api/setSessionDataFromCookie");
    let languageId = this.$store.state.api.languageId;
    if (!languageId) languageId = 1; // אם לא מוגדרת שפה שיכניס עברית כברירת מחדל
    const language = languages.find((l) => +l.id === +languageId);
    this.$store.dispatch("doLanguageSwitch", language);
    // this.checkVersion();

    this.$store.commit("setPrimevueLocale", this.$primevue.config.locale);
    this.localeConfig = JSON.parse(JSON.stringify(PrimeVueLocalConfigs));
    window.addEventListener("beforeinstallprompt", (event) => {
      // not show the default browser install app prompt
      console.log("beforeinstallprompt", event);
      // event.preventDefault();
      this.$store.commit("SetBeforeinstallpromptEvent", event);
      // window.deferPrompt = event;
    });

    // window.addEventListener(
    //   "hashchange",
    //   function(event) {
    //     console.log(window.dialogArray, event);
    //     if (!window.isBack) {
    //       if (window.dialogArray.length > 0) {
    //         let dialog = window.dialogArray[window.dialogArray.length - 1];
    //         if (dialog.func) dialog.func();
    //         // if (!this.myUrlPath) this.myUrlPath = event.oldURL;
    //         // if (event.newURL != this.myUrlPath) {
    //         //   window.history.forward();
    //         // } else {
    //         //   this.myUrlPath = null;
    //         // }
    //       }
    //     } else {
    //       window.isBack = false;
    //     }
    //   },
    //   false
    // );
  },
  setup() {
    const $store = useStore();

    onBeforeMount(() => {
      $store.dispatch("doLocalization");
    });
  },
  methods: {
    checkVersion() {
      const packageJson = require("../package.json");

      const tenant_app_min_db_var = packageJson.version
        .replace(".", "")
        .replace(".", "");
      getGlobalApi("tenant_app_min_db_var")
        .then((result) => {
          const db_version = result.replace(".", "").replace(".", "");
          const last_reload = this.$cookie.getCookie("reload_app");
          if (
            db_version > tenant_app_min_db_var &&
            (!last_reload || last_reload != new Date().toLocaleDateString())
          ) {
            this.$cookie.setCookie(
              "reload_app",
              new Date().toLocaleDateString()
            );
            location.reload(true);
          }
        })
        .catch(() => {
          errorReceived("tenant_app_min_db_var");
        });
    },
    setLocaleInPrimeVue(object) {
      for (let property in object) {
        if (Array.isArray(object[property])) {
          this.setLocaleArrayInPrimeVue(object[property], property);
        } else object[property] = __(this.localeConfig.locale[property]);
      }
    },
    setLocaleArrayInPrimeVue(object, name) {
      for (let property in object) {
        object[property] = __(this.localeConfig.locale[name][property]);
      }
    },
  },
  computed: {
    ...mapState({
      generalErrorToast: (state) => state.generalErrorToast,
      generalSuccessOrFailedModal: (state) => state.generalSuccessOrFailedModal,
      primevueLocale: (state) => state.primevueLocale,
      language: (state) => state.local,
    }),
  },
};
</script>

<style scoped>
.main {
  width: 100%;
  max-width: 500px;

  margin-left: auto;
  margin-right: auto;

  background-color: white;
}
</style>
